// Auto-generated by scripts/subset_material_symbols.py. Do not edit by hand.
// Maps Material Symbols icon names to their codepoint glyphs; the matching
// subset fonts live in src/fonts/material-symbols-{subset,fill}.woff2.
const ICON_GLYPHS = {
  "accessibility_new": "\ue92c",
  "account_circle": "\uf20b",
  "arrow_back": "\ue5c4",
  "arrow_forward": "\ue5c8",
  "auto_awesome": "\ue65f",
  "badge": "\uea67",
  "block": "\uf08c",
  "bolt": "\uea0b",
  "check": "\ue5ca",
  "check_circle": "\uf0be",
  "checkroom": "\uf19e",
  "close": "\ue5cd",
  "cloud_upload": "\ue2c3",
  "content_cut": "\ue14e",
  "delete_forever": "\ue92b",
  "do_not_disturb": "\uf08d",
  "download": "\uf090",
  "error": "\uf8b6",
  "face": "\uf008",
  "image": "\ue3f4",
  "info": "\ue88e",
  "lock": "\ue899",
  "lock_open": "\ue898",
  "lock_reset": "\ueade",
  "logout": "\ue9ba",
  "mail": "\ue159",
  "mark_email_read": "\uf18c",
  "my_location": "\ue55c",
  "open_in_new": "\ue89e",
  "palette": "\ue40a",
  "pause": "\ue034",
  "person": "\uf0d3",
  "photo_camera": "\ue412",
  "play_arrow": "\ue037",
  "psychology": "\uea4a",
  "refresh": "\ue5d5",
  "share": "\ue80d",
  "shield_lock": "\uf686",
  "summarize": "\uf071",
  "tips_and_updates": "\ue79a",
  "upload": "\uf09b",
  "verified": "\uef76",
  "verified_user": "\uf013",
  "wb_sunny": "\ue430",
};

export default ICON_GLYPHS;
